import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import {
  useAPIGetPelaksanaanPengembanganKompetensiPS,
  useAPISubmitPelaksanaanPengembanganKompetensi,
} from 'api/kinerja/pengawas-sekolah/pelaksanaan'
import { useAPIGetPerencanaan } from 'api/kinerja/pengawas-sekolah/perencanaan'

export const usePelaksanaanPengembanganKompetensiPS = () => {
  const { period, isHavePeriod } = usePeriodContext()
  const { data: perencanaan } = useAPIGetPerencanaan({
    periodId: period.id,
    enabled: isHavePeriod,
  })
  const { data: pelaksanaan, status: apiStatus } =
    useAPIGetPelaksanaanPengembanganKompetensiPS({
      skpPsId: perencanaan?.skpPsId,
      enabled: !!perencanaan?.skpPsId && isHavePeriod,
    })
  const { mutateAsync: submitPelaksanaan, status: apiStatusSubmit } =
    useAPISubmitPelaksanaanPengembanganKompetensi({
      skpPsId: perencanaan?.skpPsId,
    })

  return {
    pelaksanaan,
    submitPelaksanaan,
    apiStatus,
    apiStatusSubmit,
  }
}
